import { Truck, Info } from "lucide-react";

/**
 * Consistent disclosure that Vismarks only drives visibility & sales — logistics
 * (packing, shipping, delivery, returns) are handled by the seller.
 *
 * Variants:
 *  - "banner": full-width tinted card for landing/pages
 *  - "inline": small one-line pill for forms
 *  - "buyer": buyer-facing wording for product detail / post-purchase
 */
export default function LogisticsNotice({ variant = "banner", className = "" }) {
  if (variant === "inline") {
    return (
      <div
        data-testid="logistics-notice-inline"
        className={`inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/[0.03] px-3 py-1.5 text-[11px] text-neutral-400 ${className}`}
      >
        <Info className="h-3.5 w-3.5 text-[#007AFF]" />
        Vismarks drives sales. <span className="text-white">You handle delivery.</span>
      </div>
    );
  }
  if (variant === "buyer") {
    return (
      <div
        data-testid="logistics-notice-buyer"
        className={`rounded-md border border-[#007AFF]/30 bg-[#007AFF]/[0.06] p-3 text-xs text-neutral-300 flex items-start gap-2 ${className}`}
      >
        <Truck className="h-4 w-4 text-[#007AFF] flex-shrink-0 mt-0.5" />
        <span>
          <span className="text-white font-semibold">Delivery is arranged directly with the seller.</span>{" "}
          Vismarks powers the listing and payment; the seller ships and handles any returns.
        </span>
      </div>
    );
  }
  // banner (default)
  return (
    <div
      data-testid="logistics-notice"
      className={`rounded-xl border border-white/10 bg-white/[0.03] p-5 flex items-start gap-3 ${className}`}
    >
      <div className="h-9 w-9 rounded-md bg-[#007AFF]/10 border border-[#007AFF]/30 inline-flex items-center justify-center flex-shrink-0">
        <Truck className="h-4 w-4 text-[#007AFF]" />
      </div>
      <div>
        <div className="font-bold text-white">We drive sales, sellers drive trucks.</div>
        <p className="text-sm text-neutral-400 mt-1 leading-relaxed">
          Vismarks is a visibility &amp; discovery engine — we help sellers reach buyers and close
          sales fast. All <span className="text-white">product delivery, shipping,
          fulfilment, and returns are handled by each seller</span>. We are not a logistics
          provider or fulfilment network.
        </p>
      </div>
    </div>
  );
}
